export default "__VITE_ASSET__DGVZhnq$__"